import React, { Component } from 'react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'

class RangedTextControl extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ranges: R.pathOr([{}], ['ranges'], props.chart).map((r) => ({ ...r, key: uuidv4() })),
        }
    }

    getLocaleText = (obj) => {
        const { store } = this.props
        const { survey, surveyLocale } = store
        const { defaultLocale } = survey.metadata

        return R.pathOr(R.pathOr('', [defaultLocale], obj), [surveyLocale], obj)
    }

    changeRange = ({ value, name }, index) => {
        const { chart } = this.props
        const { ranges } = this.state
        const newRanges = [...ranges]
        newRanges[index][name.split('-')[0]] = value
        this.setState({ ranges: newRanges })
        chart.changeRanges(newRanges)
    }

    changeRangeText = (value, index) => {
        const { store, chart } = this.props
        const { surveyLocale } = store
        const { ranges } = this.state
        const newRanges = [...ranges]
        newRanges[index].rangeText = { ...newRanges[index].rangeText, [surveyLocale]: value }
        this.setState({ ranges: newRanges })
        chart.changeRanges(newRanges)
    }

    removeRange = (index) => {
        const { chart } = this.props
        const { ranges } = this.state
        const newRanges = [...ranges]
        newRanges.splice(index, 1)
        this.setState({ ranges: newRanges })
        chart.changeRanges(newRanges)
    }

    addRange = () => {
        const { ranges } = this.state
        const newRanges = [...ranges, { key: uuidv4() }]
        this.setState({ ranges: newRanges })
    }

    renderRangeOption = (index) => {
        const onRangeBlur = (field) => this.changeRange(field, index)
        const { ranges } = this.state
        return (
            <div style={{
                display: 'flex', alignItems: 'center', marginBottom: '8px', gap: '7px',
            }}
            >
                <div style={{ width: '100%' }}>
                    <Input
                        label="Range Text"
                        name={`rangeText-${index}`}
                        onBlur={(({ value }) => this.changeRangeText(value, index))}
                        defaultValue={this.getLocaleText(R.pathOr({}, [index, 'rangeText'], ranges))}
                        key={`rangeText-${R.pathOr('', [index, 'key'], ranges)}`}
                    />
                </div>
                <div style={{ width: '70px' }}>
                    <Input
                        label="Min"
                        name={`min-${index}`}
                        type="number"
                        onBlur={onRangeBlur}
                        defaultValue={R.pathOr(0, [index, 'min'], ranges)}
                        key={`min-${R.pathOr('', [index, 'key'], ranges)}`}
                        className="numberInput"
                    />
                </div>
                <div style={{ width: '70px' }}>
                    <Input
                        label="Max"
                        name={`max-${index}`}
                        type="number"
                        onBlur={onRangeBlur}
                        defaultValue={R.pathOr(0, [index, 'max'], ranges)}
                        key={`max-${R.pathOr('', [index, 'key'], ranges)}`}
                        className="numberInput"
                    />
                </div>
                <i
                    className="far fa-trash"
                    style={{ fontSize: '18px', marginTop: '24px', cursor: 'pointer' }}
                    onClick={() => this.removeRange(index)}
                />
            </div>
        )
    }

    renderRangeControls = () => {
        const { ranges } = this.state
        return ranges.map((r, i) => this.renderRangeOption(i))
    }

    render() {
        const { renderRangeControls } = this
        const { store, chart } = this.props
        const { surveyLocale } = store
        return (
            <div className="RangedTextControl">
                <div style={{
                    border: 'solid 1px black', borderRadius: '5px', marginTop: '10px', padding: '5px', marginBottom: '8px',
                }}
                >
                    {renderRangeControls()}
                    <Button
                        label="Add Range"
                        onClick={this.addRange}
                    />
                </div>

                <label htmlFor="rangeDisplayText">Display Text</label>
                <textarea
                    id="rangeDisplayText"
                    name="rangeDisplayText"
                    defaultValue={this.getLocaleText(chart.rangeDisplayText)}
                    onChange={(e) => {
                        const { value } = e.target
                        chart.changeRangeDisplayText(value, surveyLocale)
                    }}
                    style={{ height: '70px', marginBottom: '5px' }}
                />
                <label htmlFor="rangeTooltipText">Tooltip Text</label>
                <textarea
                    id="rangeTooltipText"
                    name="rangeTooltipText"
                    defaultValue={this.getLocaleText(chart.tooltipText)}
                    onChange={(e) => {
                        const { value } = e.target
                        chart.changeTooltipText(value, surveyLocale)
                    }}
                    style={{ height: '70px' }}
                />
            </div>
        )
    }
}

export default RangedTextControl
